import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ItemComponent, TileComponent } from '@tecalisdev/infinity';

import { IFormFieldPreset } from '../form-field-presets';

@Component({
	selector: 'app-form-step-type-picker',
	imports: [TileComponent, ItemComponent, TranslatePipe],
	templateUrl: './form-step-type-picker.component.html',
})
export class FormStepTypePickerComponent {
	@Input({ required: true }) fieldPresets!: IFormFieldPreset[];
	@Input() selectedPresetId: string | null = null;
	@Output() presetSelected = new EventEmitter<IFormFieldPreset>();

	public selectPreset(preset: IFormFieldPreset): void {
		this.presetSelected.emit(preset);
	}
}
